module.exports = __webpack_public_path__ + "img/2-certifications-lb_full.png";